export default __webpack_public_path__ + "static/media/834.aa909b52.gif";